// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","footerContent":"Footer_footerContent__GLsTv","buttonStyle":"Footer_buttonStyle__RKEEy"};